import { AxiosResponse } from "../interface";
import { axiosInstanceWebsite } from "../instance";
import { Product } from "../../components/products/ProductInterface";

export const getProducts = async () => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.get(`/store/product`);
    if (response.data?.length === 0) {
      return [];
    }
    const orderedProducts = response.data?.reverse();
    return orderedProducts;
  } catch (error: any) {
    console.error("Error fetching products:", error);
    // Return a generic or custom error message as needed
    throw new Error(error.response?.data?.message || "An error occurred while fetching products.");
  }
};

export const putProduct = async (data: Product) => {
  try {
    const response: AxiosResponse = await axiosInstanceWebsite.put(`/store/product/${data.id}`, data);
    return response.data;
  } catch (error: any) {
    console.error(`Error updating product with ID ${data.id}:`, error);
    // Return a generic or custom error message as needed
    throw new Error(error.response?.data?.message || `An error occurred while updating product ID ${data.id}.`);
  }
};

export const cloneProduct = async (productId: string) => {
  const response = await axiosInstanceWebsite.post(`/store/product/${productId}/clone`);
  return response.data;
}